import React, { Component } from 'react'
import { Row, Col, Form, Upload, Input, Select, Cascader, Button, Icon, Modal, Carousel, Radio, DatePicker, Card } from 'antd'
import moment from "moment"
import underscore from "underscore"
import { app } from "../../app"
import config from "../../config"
import api from "../../api"
// import moment_locale from 'antd/lib/date-picker/locale/zh_CN'
// import BraftEditor from 'braft-editor'
import { ContentUtils } from 'braft-utils'
// import { ImageUtils } from 'braft-finder'
import 'braft-editor/dist/index.css'
import date_locale from 'antd/lib/date-picker/locale/zh_CN'

const FormItem = Form.Item
const Option = Select.Option

/**
 * 上传之前2
 * @param file
 */
function beforeUpload(file) {
    const isLt2M = file.size / 1024 / 1024 < 2, types = ['image/png', 'image/jpeg']
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    } else if (types.indexOf(file.type) === -1) {
        app.alert('仅支持上传【.png, .jpg】！', 'error')
        return Promise.reject(false)
    }
    return Promise.resolve(true)
}

class EMEdit extends Component {
    constructor(props) {
        super(props)
        let selPpeList = [], searchplayerList = [], head_img = null, regionsOptions = []
        if (props.info) {
            // console.log(props.info)
            // selPpeList = props.info.ppe_class || []
            searchplayerList.push({
                indexno: props.info.indexno,
                vname: props.info.name,
                localpath: props.info.head_img,
                sex: props.info.sex,
                mobile: props.info.mobile,
                bsrno: props.info.bsrno
            })
            head_img = props.info.head_img
        }
        if (props.regionsOptions2) {
            regionsOptions = props.regionsOptions2
        }
        this.carouselBox = React.createRef()
        this.state = {
            showImgPreview: false, // 是否显示预览图片弹窗
            statuslList: [], // 寻人状态数组
            fileListLength: 0, // 上传图片的数量
            fileListArr: [], // 上传图片的数组
            regionsOptions,
            search_loading: false,
            photo_loading: false,
            submit_loading: false,
            searchplayerList,
            selPpeList,
            head_img,
            xunrenType: [
                {
                    type_title: '家寻亲人',
                    type: 1,
                },

                {
                    type_title: '亲人寻家',
                    type: 2,
                },

                {
                    type_title: '感恩寻人',
                    type: 3,
                },

                {
                    type_title: '寻找老友',
                    type: 4,
                },

                {
                    type_title: '战友情深',
                    type: 5,
                },

                {
                    type_title: '台海寻人',
                    type: 6,
                },

                {
                    type_title: '其他寻人',
                    type: 7,
                }
            ],
        }
    }

    componentDidMount() {
        this._isMounted = true
        // 获取状态
        this.positionalSource();
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                const { statuslList, regionsOptions } = this.state;

                await this.setData({ submit_loading: true })
                values.employ_start = moment(values.date).format('YYYY-MM-DD')
                values.employ_start2 = moment(values.birthday).format('YYYY-MM-DD')
                values.expiry_date = moment(values.expiry_date).format('YYYY-MM-DD')
                const certificate_img = []
                for (let i = 0; i < values.certificate_img.length; i++) {
                    if (values.certificate_img[i].response && values.certificate_img[i].response.flag === 1) {
                        certificate_img.push(values.certificate_img[i].response.data.url)
                    }
                }
                values.certificate_img = certificate_img.join(':::')

                if (!app.getData('findAsstoken')) {
                    app.alert("请先登录", 'warn')
                    return;
                }
                let family_info = {
                    family_name1: values.family_name1 ? values.family_name1 : '', // 家属联系人1姓名
                    family_phone1: values.family_phone1 ? values.family_phone1 : '',  // 家属联系人1手机号
                    family_name2: values.family_name2 ? values.family_name2 : '', // 家属联系人2姓名
                    family_phone2: values.family_phone2 ? values.family_phone2 : '',  // 家属联系人2手机号
                };
                // 判断第一联系人是否填写
                if (family_info.family_name1 !== '') {
                    if (family_info.family_phone1 === '') {
                        app.alert("请填写第一联系人手机号");
                        return;
                    }
                }
                // 判断第二联系人是否填写
                if (family_info.family_name2 !== '') {
                    if (family_info.family_phone2 === '') {
                        app.alert("请填写第二联系人手机号");
                        return;
                    }
                }
                if (family_info.family_phone1 !== '') {
                    if (family_info.family_name1 === '') {
                        app.alert("请填写第一联系人姓名");
                        return;
                    }
                }
                if (family_info.family_phone2 !== '') {
                    if (family_info.family_name2 === '') {
                        app.alert("请填写第二联系人姓名");
                        return;
                    }
                }
                if ((family_info.family_name1 === '' && family_info.family_name2 === '') || (family_info.family_phone1 === '' && family_info.family_phone2 === '')) {
                    app.alert("至少填写一个联系方式");
                    return;
                }

                let flagStatus = '';
                // 根据寻人状态名称获取对应id
                if (values.flag_title !== '' || values.flag_title !== null || values.flag_title !== undefined) {
                    statuslList.forEach(e => {
                        if (e.title == values.flag_title) {
                            flagStatus = e.id
                        }
                    })
                }

                // 判断发布人姓名是否为空
                if (values.report_name === '') {
                    app.alert("发布人姓名为空，请重新登录再试", "warn");
                    return;
                }
                // 判断发布人手机号是否为空
                if (values.report_mobile === '') {
                    app.alert("发布人手机号为空，请重新登录再试", "warn");
                    return;
                }
                // 判断发布人身份证是否为空
                if (app.getData('findIdno') === '') {
                    app.alert("发布人身份证为空，请重新登录再试", "warn");
                    return;
                }

                let
                    province2,
                    province2_name,
                    city2,
                    city2_name,
                    district2,
                    district2_name = '';

                if (values.pcs.length > 1 || values.pcs.length == 1) {
                    // 省id
                    province2 = values.pcs[0];
                    // console.log(regionsOptions);
                    regionsOptions.forEach(e => {
                        // 获取省名称
                        if (e.value == province2) {
                            province2_name = e.label
                            // console.log(e.children);
                            if (values.pcs.length > 2 || values.pcs.length == 2) {
                                city2 = values.pcs[1];
                                e.children.forEach(r => {
                                    // 获取市名称
                                    if (r.value == city2) {
                                        console.log('获取市名称: ' + r.label);
                                        console.log(r);
                                        city2_name = r.label
                                        if (values.pcs.length > 3 || values.pcs.length == 3) {
                                            console.log("进来了")
                                            district2 = values.pcs[2];
                                            console.log("district2: " + district2);
                                            r.children.forEach(t => {
                                                console.log(t.label);
                                                // 获取区名称
                                                if (t.value == district2) {
                                                    district2_name = t.label
                                                };
                                            })
                                        }
                                    };
                                })
                            }
                        };
                    })
                }

                let dataForm = {
                    report_name: values.report_name,	// 发布人姓名
                    report_mobile: values.report_mobile, // 发布人手机号
                    report_idno: app.getData('findIdno'), // 发布人身份证号
                    name: values.name, // 失踪人姓名
                    sex: values.sex, // 性别(男女)
                    // age: values.age, // 年龄
                    height: values.height, // 身高
                    weight: values.weight, // 体重
                    feature: values.feature, // 特征
                    descript: values.descript, // 概括
                    detail: '', // 详细地址
                    family_info: JSON.stringify(family_info), // 联系人
                    flag: flagStatus, // 寻人状态
                    open_contact: values.open_contact, // 是否公开联系方式
                    type: values.type, // 寻人类型
                    img_path: values.certificate_img,   // 图片路径
                    date: values.employ_start,   // 走失时间    
                    birthday: values.employ_start2,   // 出生日期    
                    province: province2_name || '',   // 失踪省份
                    city: city2_name || '',   // 失踪地市
                    district: district2_name || '',   // 失踪地区/ 区域
                    address: values.address,// 走失地址
                    lost_token: app.getData('findAsstoken'), // 登录token
                };
                console.log(values.pcs);
                console.log(dataForm)
                const { info } = this.props
                let flag = await this.props.success(dataForm, info ? info.id : undefined)
                if (flag) {
                    await this.setData({ submit_loading: false, searchplayerList: [], selPpeList: [], head_img: null })
                    this.props.form.resetFields()
                }

            }
        })
    }

    // 点击预览图片
    onOnPreview = (e) => {
        const { fileListArr } = this.state;
        // console.log(e)
        // const { fileListArr } = this.state;
        // 打开图片预览弹窗        
        // 获取点击预览下标
        if (fileListArr.length > 0) {
            // 打开弹窗
            this.setData({
                showImgPreview: true,
            })

            // 由于carouselBox是弹窗，只有在弹窗显示的时候才能获取到里面的值，所以设置定时器确保carouselBox已经渲染。
            setTimeout(() => {
                fileListArr.forEach((t, ti) => {
                    if (t.uid === e.uid) {
                        this.carouselBox.current.innerSlider.slickGoTo(ti); // 拿到下标
                    }
                })
                // console.log(this.carouselBox)
            }, 800);
        }

        // console.log(fileListArr);
    }

    // 是否开启关闭预览图片弹窗
    handleClosePreviewModal = () => {
        if (this.state.showImgPreview) {
            this.setData({
                showImgPreview: false,
            })
        } else {
            this.setData({
                showImgPreview: true,
            })
        }
    }

    // 监听上传图片
    monitorUploadImg = (info) => {
        if (info.file.status === 'uploading') {
            this.setData({ photo_loading: true })
            return
        }
        if (info.file.status === 'done') {
            const state = { photo_loading: false }
            this.setData(state)
        }
        console.log(info);
        let fileListArr = [];
        if (info.fileList.length > 0) {
            info.fileList.forEach(e => {
                // 上传成功，push图片路径到数组
                if (e.response.flag === 1) {
                    fileListArr.push(
                        {
                            url: config.imgUrl + e.response.data.url,
                            uid: e.uid
                        }
                    )
                }
            })
        }
        console.log(fileListArr);
        setTimeout(() => {
            this.setData({
                fileListLength: info.fileList.length,
                fileListArr,
            })
        }, 500);
    }

    /**
     * 寻找状态数据
     */
    positionalSource = async () => {
        // const params = {
        //     indexno: app.getData('indexno'),
        //     account: app.getData('account'),
        // }
        let { flag, data, msg } = await app.post(api.LostMessageStatusLists, {})
        const state = { posi_loading: false }
        if (flag === 1) {
            state.statuslList = data.list
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    render() {
        let { info, cancel, } = this.props,
            { getFieldDecorator, getFieldValue } = this.props.form,
            { regionsOptions, xunrenType, fileListLength, fileListArr, statuslList, photo_loading, showImgPreview } = this.state
        return (
            <div>
                <Form layout='inline' onSubmit={this.handleSubmit}>
                    <div style={{ fontSize: '23px', color: 'red', textAlign: 'center', marginBottom: '24px', padding: 0 }}><Icon type="warning" /> 请您遵守国家法律法规，请勿发布虚假信息，您对您的发布负有法律责任</div>
                    <Row gutter={18}>
                        <Card size='small'
                            title={
                                <div style={{ fontWeight: '500', fontSize: 18 }}>发布人</div>
                            } style={{ marginBottom: '16px' }}
                            extra={<span style={{ color: 'red' }}> <Icon type="info-circle" /> 发布人信息不对外公示</span>}
                        >
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="发布人姓名"
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('report_name', {
                                        // rules: [
                                        //     { required: true, message: '请输入发布人姓名' }
                                        // ],
                                        initialValue: app.getData('findName') || ''
                                    })(
                                        <Input disabled placeholder="请输入发布人姓名" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="发布人手机号"
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('report_mobile', {
                                        // rules: [
                                        //     { required: true, message: '请输入发布人手机号' }
                                        // ],
                                        initialValue: app.getData('findMobile') || ''
                                    })(
                                        <Input disabled placeholder="请输入发布人手机号" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={{
                                ...styles,
                            }}>
                                <FormItem
                                    label="寻人类型"
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('type', {
                                        rules: [
                                            { required: true, message: '请选择寻人类型' }
                                        ],
                                        initialValue: info ? info.type_title : ''
                                    })(
                                        <Select placeholder="请选择寻人类型" style={{ width: '184px' }}>
                                            <Option value="">-未选择-</Option>
                                            {
                                                xunrenType.map((e, i) => {
                                                    return (
                                                        <Option key={i} value={e.type}>{e.type_title}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )}
                                </FormItem>

                            </Col>
                        </Card>

                        <Card size='small'
                            // title={<div style={{ fontWeight: '700', fontSize: 24, textAlign: 'center' }}>被寻人基本信息</div>}
                            // style={{ marginBottom: '16px' }}
                            title={
                                <div style={{ fontWeight: '500', fontSize: 18 }}>被寻人基本信息</div>
                            } style={{ marginBottom: '16px' }}
                        >
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="被寻人姓名"
                                    style={{
                                        position: 'relative',
                                        left: '-36px',
                                    }}
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('name', {
                                        rules: [
                                            { required: true, message: '请输入被寻人姓名' }
                                        ],
                                        initialValue: info ? info.name : ''
                                    })(
                                        <Input style={{ width: '146px' }} placeholder="请输入被寻人姓名" />
                                    )}
                                </FormItem>

                            </Col>
                            <Col span={12}>
                                <FormItem
                                    label="性别"
                                    style={{ marginLeft: '124px' }}
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('sex', {
                                        rules: [
                                            { required: true, message: '请选择性别' }
                                        ],
                                        initialValue: info ? info.sex : ''
                                    })(
                                        <Select placeholder="请选择性别" style={{ width: '146px' }}>
                                            <Option value="">-未选择-</Option>
                                            <Option value="男">男</Option>
                                            <Option value="女">女</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="体重"
                                    style={{
                                        position: 'relative',
                                        left: '-36px',
                                    }}
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('weight', {
                                        rules: [
                                            { required: true, message: '请输入体重' }
                                        ],
                                        initialValue: info ? info.weight : ''
                                    })(
                                        <Input style={{ width: '146px' }} placeholder="请输入体重" addonAfter="公斤" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={{
                                ...styles,
                                position: 'relative',
                                left: '-35px'
                            }}>
                                <FormItem
                                    label="身高"
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('height', {
                                        rules: [
                                            { required: true, message: '请输入身高' }
                                        ],
                                        initialValue: info ? info.height : ''
                                    })(
                                        <Input style={{ width: '146px' }} placeholder="请输入身高" addonAfter="厘米" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="出生日期"
                                    style={{
                                        position: 'relative',
                                        left: '-36px',
                                    }}
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('birthday', {
                                        rules: [
                                            { required: true, message: '请输入走失时间' }
                                        ],
                                        initialValue: info ? (info.birthday === '0000-00-00 00:00:00' || info.birthday === '' ? null : moment(info.birthday)) : null
                                    })(
                                        <DatePicker
                                            style={{ width: '146px' }}
                                            locale={date_locale}
                                            format="YYYY年MM月DD日"
                                            disabledDate={current => current && current > moment().endOf('second')}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="走失时间"
                                    style={{
                                        position: 'relative',
                                        left: '-36px',
                                        marginBottom: '16px'
                                    }}
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('date', {
                                        rules: [
                                            { required: true, message: '请输入走失时间' }
                                        ],
                                        initialValue: info && info.date ? moment(info.date) : null
                                    })(
                                        <DatePicker
                                            style={{ width: '146px' }}
                                            locale={date_locale}
                                            format="YYYY年MM月DD日"
                                            disabledDate={current => current && current > moment().endOf('second')}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={24} style={{ marginBottom: '16px' }}>
                                <FormItem
                                    label="特征描述"
                                    style={{ marginLeft: '97px' }}
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('feature', {
                                        rules: [
                                            { required: true, message: '请输入特征' }
                                        ],
                                        initialValue: info ? info.feature : ''
                                    })(
                                        <Input.TextArea style={{ width: '546px' }} placeholder="请输入特征" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={24}>
                                <FormItem
                                    label="相关照片"
                                    style={{ marginLeft: '97px' }}
                                // {...formItemLayout(20)}
                                >
                                    {getFieldDecorator('certificate_img', {
                                        rules: [
                                            { required: true, message: "相关照片必传！" },
                                        ],
                                        valuePropName: 'fileList',
                                        getValueFromEvent: (e) => {
                                            if (Array.isArray(e)) {
                                                return e
                                            }
                                            return e && e.fileList
                                        },
                                        initialValue: info ? ((info.img_path == '' || info.img_path == undefined) ? [] : info.img_path.split(":::")).map((img, i) => {
                                            i += 1
                                            return {
                                                uid: i - i * 2,
                                                status: 'done',
                                                response: {
                                                    flag: 1,
                                                    data: {
                                                        url: img
                                                    }
                                                },
                                                name: "图片" + i,
                                                thumbUrl: config.imgUrl + img
                                            }
                                        }) : []
                                    })(
                                        <Upload
                                            accept='image/jpeg, image/jpg, image/png'
                                            action={config.serverUrl + api.ImageUpload}
                                            beforeUpload={beforeUpload}
                                            data={{
                                                token: app.getData('token'),
                                                indexno: app.getData('indexno'),
                                                account: app.getData('account'),
                                                upload_type: 'lost_message'
                                            }}
                                            name="image"
                                            listType="picture"
                                            showUploadList={true}
                                            className="upload-list-inline"
                                            onChange={(e) => this.monitorUploadImg(e)}
                                            onPreview={this.onOnPreview}
                                        >

                                            {fileListLength < 3 ?
                                                <Button type="primary"><Icon type={photo_loading ? 'loading' : 'upload'} /> 点击上传</Button>
                                                :
                                                null
                                            }

                                        </Upload>
                                    )}
                                    (最多上传3张照片，默认显示首张)
                                </FormItem>
                            </Col>
                        </Card>

                        <Card size='small'
                            title={
                                <div style={{ fontWeight: '500', fontSize: 18 }}>联系人信息</div>
                            }
                            style={{ marginBottom: '16px' }}
                            extra={<span style={{ color: 'red' }}><Icon type="info-circle" /> 至少填写一个联系方式（为防止诈骗，您的联系方式默认不公开）</span>}
                        >
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="第一联系人姓名"
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('family_name1', {
                                        rules: [
                                            { required: false, message: '请输入第一联系人姓名' }
                                        ],
                                        initialValue: info ? (info.family_info !== null ? (
                                            info.family_info.family_name1 !== '' ? info.family_info.family_name1 : ''
                                        ) : '') : ''
                                    })(
                                        <Input placeholder="请输入第一联系人姓名" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="第二联系人姓名"
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('family_name2', {
                                        rules: [
                                            { required: false, message: '请输入第二联系人姓名' }
                                        ],
                                        initialValue: info ? (info.family_info !== null ? (
                                            info.family_info.family_name2 !== '' ? info.family_info.family_name2 : ''
                                        ) : '') : ''
                                    })(
                                        <Input placeholder="请输入第二联系人姓名" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="第一联系人手机号"
                                >
                                    {getFieldDecorator('family_phone1', {
                                        rules: [
                                            { required: false, message: '请输入第一联系人手机号' }
                                        ],
                                        initialValue: info ? (info.family_info !== null ? (
                                            info.family_info.family_phone1 !== '' ? info.family_info.family_phone1 : ''
                                        ) : '') : ''
                                    })(
                                        <Input placeholder="请输入第一联系人手机号" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="第二联系人手机号"
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('family_phone2', {
                                        rules: [
                                            { required: false, message: '请输入第二联系人手机号' }
                                        ],
                                        initialValue: info ? (info.family_info !== null ? (
                                            info.family_info.family_phone2 !== '' ? info.family_info.family_phone2 : ''
                                        ) : '') : ''
                                    })(
                                        <Input placeholder="请输入第二联系人手机号" />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12} style={styles}>
                                <FormItem
                                    label="是否公开联系方式"
                                    style={{
                                        position: 'relative',
                                        left: '-75px'
                                    }}
                                >
                                    {getFieldDecorator('open_contact', {
                                        rules: [
                                            { required: false, message: '请选择是否公开联系方式' }
                                        ],
                                        initialValue: info ? info.open_contact : '0'
                                    })(
                                        <Radio.Group>
                                            <Radio value='0'>否</Radio>
                                            <Radio value='1'>是</Radio>
                                        </Radio.Group>
                                    )}
                                </FormItem>
                            </Col>
                        </Card>

                        <Card size='small'
                            title={
                                <div style={{ fontWeight: '500', fontSize: 18 }}>详细信息</div>
                            } style={{ marginBottom: '16px' }}
                        >
                            <Col span={24} style={{ marginBottom: '16px' }}>
                                <FormItem
                                    label="事发省市区"
                                    style={{ marginLeft: '80px' }}
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('pcs', {
                                        rules: [
                                            { required: true, message: '请选择事发省市区' }
                                        ],
                                        initialValue: info ? [(info.province || ''), (info.city || ''), (info.district || '')] : ''
                                        // initialValue: ''
                                    })(
                                        <Cascader style={{ width: '571px' }} placeholder="请选择事发省市区" options={regionsOptions} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={24} style={{ marginBottom: '16px' }}>
                                <FormItem
                                    label="事发地址"
                                    style={{ marginLeft: '96px' }}
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('address', {
                                        rules: [
                                            { required: true, message: '请输入事发地址' }
                                        ],
                                        initialValue: info ? info.address : ''
                                    })(
                                        <Input.TextArea style={{ width: '571px' }} placeholder="请输入事发地址" />
                                    )}
                                </FormItem>
                            </Col>

                            <Col span={24}>
                                <FormItem
                                    label="事发概况"
                                    style={{
                                        position: 'relative',
                                        left: '95px'
                                    }}
                                // {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('descript', {
                                        rules: [
                                            { required: true, message: '请输入事发概况' }
                                        ],
                                        initialValue: info ? info.descript : ''
                                    })(
                                        <Input.TextArea rows={4} style={{ width: '568px' }} placeholder="请输入事发概况" />
                                    )}
                                </FormItem>
                            </Col>

                        </Card>

                        {/* 编辑的时候显示 */}
                        {
                            info ?
                                <Card size='small'
                                    title={
                                        <div style={{ fontWeight: '500', fontSize: 18 }}>寻人实况</div>
                                    } style={{ marginBottom: '16px' }}
                                >
                                    <Col span={12}>
                                        <FormItem
                                            label="寻人状态"
                                            style={{ marginLeft: '96px' }}
                                        // {...formItemLayout(8)}
                                        >
                                            {getFieldDecorator('flag_title', {
                                                rules: [
                                                    { required: true, message: '请选择寻人状态' }
                                                ],
                                                initialValue: info ? info.flag_title : ''
                                            })(
                                                // 1寻找中；2已找到；3已撤销；4已逝世；5已过期
                                                <Select placeholder="请选择寻人状态">
                                                    <Option value="">-未选择-</Option>
                                                    {
                                                        statuslList.map(p => (
                                                            <Option value={p.title} key={p.id} id={p.id} disabled={p.id === 0}>{p.title}</Option>
                                                        ))
                                                    }
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={24}>
                                        <FormItem
                                            label="找到地址"
                                            style={{
                                                position: 'relative',
                                                left: '95px'
                                            }}
                                        // {...formItemLayout(8)}
                                        >
                                            {getFieldDecorator('find_at', {
                                                rules: [
                                                    { required: true, message: '请输入找到地址' }
                                                ],
                                                initialValue: info ? info.descript : ''
                                            })(
                                                <Input.TextArea rows={4} style={{ width: '568px' }} placeholder="请输入找到地址" />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Card>
                                :
                                null
                        }
                    </Row>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button style={{ marginLeft: '2rem' }} onClick={cancel}>取消</Button>
                    </div>
                </Form>
                <Modal
                    visible={showImgPreview}
                    title='图片预览'
                    maskClosable={false}
                    width='538px'
                    style={{ padding: 0, top: 78 }}
                    destroyOnClose={true}
                    footer={false}
                    onCancel={this.handleClosePreviewModal}
                >
                    <Carousel ref={this.carouselBox}>
                        {
                            (fileListArr || []).map((e, i) => {
                                return (
                                    <div key={e.uid} style={{ width: '509px', height: '540px', background: '#fff', borderRadius: '4px' }}>
                                        <img style={{ maxWidth: '509px', maxHeight: '540px', borderRadius: '4px' }}
                                            src={e.url} alt="相关照片" />
                                    </div>
                                )
                            })
                        }
                    </Carousel>
                </Modal>
            </div>
        )
    }
}

export default Form.create()(EMEdit)

const styles = {
    display: 'flex',
    justifyContent: 'flex-end'
}


// WEBPACK FOOTER //
// ./src/routes/find/FMEdit.jsx